export const handleImage = image => {
	if (image) {
		// image = image?.replaceAll("/storage", " ");
		if (image?.includes("https://") || image?.includes("http://")) return image;
		if (!image.startsWith("/")) image = `/${image}`;
		return `${`${process.env.REACT_APP_MAIN_URL}`?.replace(
			"/api",
			""
		)}${image}`;
	}
	return "";
};

export const formatDate = date => {
	const options = { year: "numeric", month: "long", day: "numeric" };
	return new Date(date).toLocaleDateString(undefined, options);
};
